import React, { useEffect, useState } from 'react';
import api, { unwrap } from '../utils/api';

export default function Watermarks() {
  const [list, setList] = useState([]);
  const [file, setFile] = useState(null);
  const [name, setName] = useState('');

  async function load() {
    const r = await api.get('/files/watermarks');
    setList(unwrap(r) || []);
  }
  useEffect(() => { load(); }, []);

  async function upload() {
    if (!file) return;
    const fd = new FormData();
    fd.append('file', file);
    fd.append('name', name || file.name);
    await api.post('/files/SaveWatermark', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
    setFile(null); setName('');
    load();
  }

  async function setDefault(_id) {
    await api.post('/miscellaneous/SetDefaultWatermarkId', { _id });
    alert('Default set.');
  }

  async function remove(_id) {
    await api.post('/files/DeleteWatermark', { _id });
    load();
  }

  return (
    <>
      <h1>Watermarks</h1>
      <div className="card">
        <div className="row">
          <input type="file" accept="image/*" onChange={e => setFile(e.target.files[0])} />
          <input placeholder="Name" value={name} onChange={e => setName(e.target.value)} />
          <button className="btn" onClick={upload} disabled={!file}>Upload</button>
        </div>
      </div>
      <div className="card">
        <table className="table">
          <thead><tr><th>Preview</th><th>Name</th><th>Default</th><th></th></tr></thead>
          <tbody>
            {list.map(w => (
              <tr key={w._id}>
                <td>{w.path ? <img src={w.path} alt="" style={{ height: 40 }} /> : '—'}</td>
                <td>{w.name}</td>
                <td>{w.isDefault ? 'Yes' : <button className="btn small secondary" onClick={() => setDefault(w._id)}>Set default</button>}</td>
                <td><button className="btn small danger" onClick={() => remove(w._id)}>Del</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}
